<template>
   <div class="imgBoxS">   <!--:on-preview="handlePictureCardPreview" -->
    <el-upload class="upload-demo" action=""  drag  :file-list="fileArr" ref="upload" :auto-upload=false
    :on-change="imgPreview" :limit="max"  :disabled="delFlag" multiple :on-exceed="handleExceed"
    :on-remove="handleRemove" :on-preview="handlePicPreview" :class="[isAdd?'hidden':'']">
      <i class="el-icon-upload"></i>
      <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
    </el-upload>
    <div style="font-size:12px;color:red;" v-if="max>1">最多上传{{max}}个文件</div>
    <el-image-viewer v-if="dialogVisible" :on-close="closeViewer" :url-list="lookimgList" />
  </div>
</template>

<script>
import ElImageViewer from 'element-ui/packages/image/src/image-viewer'

export default {
  components: { ElImageViewer },
  name: 'uploadImgs',
  props: {
    fileArr: {
      type: Array,
      default: function () {
        return []
      }
    },

    max: {
      type: Number,
      default: 1
    }
  },
  data () {
    return {
      lookimgList: [],
      dialogImageUrl: '',
      isAdd: false,
      dialogVisible: false,
      delFlag: false

    }
  },
  mounted: function () { // 在更新DOM之前 调用此钩子函数 应用：可以获取原始的DOM
    if (this.fileArr.length == this.max) {
      this.isAdd = true
    }
  },
  methods: {
    // 一次性选择的文件超出限制时，即时提示
    handleExceed (files, fileList) {
      console.log(fileList)
      // 计算还能选多少个：最大数 - 已选数
      const remainCount = this.max - fileList.length
      this.$message.warning(`最多只能选择${this.max}个文件，当前已选择${fileList.length}个，还能选择${remainCount}个！`)
    },
    // 图片上传
    handleRemove (file, fileList) {
      this.$emit('update:fileArr', fileList)
      this.$emit('remove', file)
      if (fileList.length < this.max) {
        this.isAdd = false
      }
      this.lookimgList = []
      fileList.forEach((item, index) => {
        let regex = /(.jpg|.jpeg|.png|)$/
        if (regex.test(item.name.toLowerCase())) {
          this.$set(this.lookimgList, index, item.url)
        }
      })
    },
    closeViewer () {
      this.dialogVisible = false
    },
    imgPreview (file, fileList) {
      this.lookimgList = []
      fileList.forEach((item, index) => {
        let regex = /(.jpg|.jpeg|.png|)$/
        if (regex.test(item.name.toLowerCase())) {
          this.$set(this.lookimgList, index, item.url)
        }
      })
      this.$emit('update:fileArr', fileList)
      this.$emit('change', fileList)
      if (fileList.length < this.max) {
        this.isAdd = false
      } else {
        this.isAdd = true
      }
    },
    handlePictureCardPreview (file) {
      console.log(file)
      if (this.lookimgList.length == 0) {
        this.fileList.forEach((item, index) => {
          let regex = /(.jpg|.jpeg|.png|)$/
          if (regex.test(item.name.toLowerCase())) {
            this.$set(this.lookimgList, index, item.url)
          }
        })
        this.lookimgList.forEach((item, index) => {
          if (item == file.url) {
            this.lookimgList = this.lookimgList.slice(index).concat(this.lookimgList.slice(0, index))
            this.dialogVisible = true
          }
        })
      } else {
        this.lookimgList.forEach((item, index) => {
          if (item == file.url) {
            this.lookimgList = this.lookimgList.slice(index).concat(this.lookimgList.slice(0, index))
            this.dialogVisible = true
          }
        })
      }
    },
    handlePicPreview (file) {
      this.$emit('handlePicPreview', file)
    }
  },
  destroyed () {

  }
}
</script>

<style scoped lang='less' >
.imgBoxS {
  margin: 5px;
  width: 500px;
}

.hidden /deep/.el-upload--text {
  display: none;
}
.imgDialog /deep/.el-dialog__body {
  text-align: center;
}
/deep/.el-upload-list--picture-card .el-upload-list__item-actions{
  font-size:30px;
  .el-upload-list__item-delete{
    margin-left: 30px;
  }
}
/deep/.el-upload-dragger{
    width: 200px;
    height: 90px;
}
/deep/.el-upload-dragger .el-icon-upload{
  font-size: 47px;
  color: #C0C4CC;
  line-height: 50px;
  margin: 0;
}
</style>
